<template>
    <div id="nav" :class="this.type">      
        <router-link to="/" class="home"><span>Home</span></router-link>
        <div class="menu">
            <router-link to="/support"><span>플레이 서포트</span></router-link>
            <router-link to="/hunting"><span>사냥터 리뉴얼</span></router-link>
            <router-link to="/item"><span>아이템 리뉴얼</span></router-link>
            <router-link to="/revenge"><span>리벤지 시스템</span></router-link>
            <router-link to="/world"><span>월드 공성전</span></router-link>
        </div>

    </div>    
</template>

<script>
import {mapState} from "vuex";

export default {
    computed: {
        ...mapState([
            "currentPage"
        ]),
        type(){
            let className;
            if(this.currentPage == "home"){
                className = "left";
            }else{
                className = 'top'
            }
            return className;
        }
    }    
}
</script>

<style lang="scss">
    #nav {
        @include position-abs($width:1200px, $height:32px, $left:63px, $top:88px); z-index:10;

        >.home{
            @include hide-text;
            @include position-abs($width:257px, $height:32px, $left:0px, $top:0);
            @include bg($bg:'img/logo.png', $position:0 0);
        }
        .menu{
            padding-left:310px;
            &>a{
                @include hide-text;
                position:relative;
                display: block;
                float:left;
                width:145px;
                height:30px;
                margin-bottom:15px;

                &>span{
                    display: block;
                    @include position-abs($width:145px, $height:30px, $left:10px, $top:0);
                    &:before{
                        display: block;
                        @include position-abs($width:145px, $height:30px, $left:0px, $top:0);
                        @include bg($bg:'img/nav_txt.png', $position:0 0);
                        content: '';
                        transition:0.3s;
                    }
                    &:after{
                        display: block;
                        @include position-abs($width:145px, $height:30px, $left:0px, $top:0);
                        @include bg($bg:'img/nav_txt.png', $position:0 -30px);
                        content: '';
                        opacity:0;
                        transition:0.3s;
                    }
                }

                &:before{
                    @include position-abs($width:30px, $height:30px, $left:-4px, $top:0);
                    display: block;
                    content: '';
                    @include bg($bg:'img/nav_ico_off_1.png', $position:0 0);
                }
                &:first-child:before{
                    display: none;
                }
                &:after{
                    @include position-abs($width:30px, $height:30px, $left:-4px, $top:0);
                    display: block;
                    content: '';
                    @include bg($bg:'img/nav_ico_on.png', $position:0 0);
                    opacity:0;
                    transform: scale(0.5) rotate(-180deg);
                    transition:0.3s;
                }

                &:hover, &.router-link-exact-active{

                    &:after {
                        opacity: 1;
                        transform: scale(1);
                        transition:0.3s;
                    }
                    >span:after{
                        opacity:1;
                        transition:0.3s;
                    }
                    >span:before{
                        opacity:0;
                        transition:0.3s;
                    }
                }

                &:nth-child(2){
                    &>span:before, &>span:after{background-position-x: -145px};
                }
                &:nth-child(3){
                    &>span:before, &>span:after{background-position-x: -290px};
                }
                &:nth-child(4){
                    &>span:before, &>span:after{background-position-x: -435px};
                }
                &:nth-child(5){
                    &>span:before, &>span:after{background-position-x: -580px};
                }
            }
        }

        &.left{
            @include position-abs($width:160px, $height:592px, $left:50px, $top:50%); z-index:10;
            @include bg($bg:'img/nav_bg.png', $position:7px 0);

            animation: navi-animation 2s;
            .home{display: none;}
            .menu {
                padding-left:0;
                padding-top: 190px;
                &>a {
                    &:before {
                        @include position-abs($width: 30px, $height: 30px, $left: -4px, $top: 0);
                        display: block;
                        content: '';
                        @include bg($bg: 'img/nav_ico_off_2.png', $position: 0 0);
                    }
                }
            }
        }
        &.top{
            animation: navi-animation1 2s;
        }

    }

    @keyframes navi-animation {
        from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
    @keyframes navi-animation1 {
        from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
</style>


